<div class="content-view-box">
  <ng-container *ngIf="data?.file">
    <img [src]="getFileUrl()" />
  </ng-container>
  <div class="content-view-body">
    <div *ngIf="data?.content" class="content-view-html innerHtml" [innerHTML]="data?.content | safe: 'html'"></div>
  </div>
</div>
